<template>
    <div style="min-width:900px;">
        <div class="pkg-search-box grow-comment-manage">
            <el-form class="pkg-content" label-position="left"
                     :model="dataForm"
                     @keyup.enter.native="getDataList()">
                <el-row class="margb10">
                    <el-col :span="7">
                        <!-- 标题 -->
                        <el-form-item label="标题"
                                      class="search-item">
                            <el-input v-model="dataForm.title"
                                      placeholder="请输入标题"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <!-- 标签 -->
                        <el-form-item label="标签"
                                        class="search-item">
                            <el-input v-model="dataForm.tag"
                                        placeholder="请输入标签"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <!-- 作品/回答提交人 -->
                        <el-form-item label="提交人"
                                      class="search-item">
                            <el-input v-model="dataForm.worksSubmitter"
                                      placeholder="请输入ID/名字/员工号"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- 查询 -->
                    <el-col :span="3">
                        <el-col :span="24">
                            <el-button class="M-search"
                                       style="margin-bottom: 7px"
                                       type="primary"
                                       @click="getDataListMerge">查询</el-button>
                        </el-col>
                    </el-col>
                </el-row>
                <el-row class="margb10">
                    <el-col :span="7">
                        <!-- 状态 -->
                        <el-form-item label="状态"
                                        class="search-item">
                            <el-select v-model="dataForm.status"
                                        placeholder="请选择"
                                        clearable>
                                <el-option v-for="(item,index) in statusOptions"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="9">
                        <!-- 提交时间 -->
                        <el-form-item label="提交时间"
                                    class="search-item"
                                      style="width: 100% !important">
                            <el-date-picker v-model="submitTime"
                                            type="daterange"
                                            value-format="yyyy-MM-dd"
                                            start-placeholder="开始时间"
                                            end-placeholder="结束时间"
                                            :clearable="true"
                                            style="width: 100%">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5"><span>&nbsp;</span></el-col>
                    <el-col :span="3">
                        <!-- 重置 -->
                        <el-col :span="24">
                            <el-button class="el-back M-search M-margin-l"
                                       type="info"
                                       @click="again">重置</el-button>
                        </el-col>
                    </el-col>
                </el-row>
                <el-row>
                  <el-col :span="7">
                    <!-- 类型 -->
                    <el-form-item label="类型"
                                  class="search-item">
                      <el-select v-model="dataForm.manageType"
                                 placeholder="请选择"
                                 clearable>
                        <el-option v-for="(item,index) in manageTypeOptions"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="pkg-content">
            <el-table v-loading="dataListLoading"
                      :data="dataList"
                      tooltip-effect="dark"
                      border
                      :row-style="{height:48+'px'}"
                      :cell-style="{padding:0+'px'}">
                <!--序号-->
                <el-table-column label="序号"
                                 type="index"
                                 width="50"
                                 align="center"
                                 show-overflow-tooltip>
                    <template slot-scope='scope'><span>{{(page-1)*limit + scope.$index+1}}</span></template>
                </el-table-column>
                <!-- 类型 -->
                <el-table-column prop="manageType"
                                 label="类型"
                                 header-align="center"
                                 align="left"
                                 :formatter="manageTypeformat"
                                 width="80"
                                 show-overflow-tooltip></el-table-column>
                <!--标题-->
                <el-table-column prop="worksTitle"
                                 label="标题"
                                 header-align="center"
                                 align="left"
                                 width="180"
                                 show-overflow-tooltip></el-table-column>
                <!--标签-->
                <el-table-column prop="worksTag"
                                 label="标签"
                                 header-align="center"
                                 align="left"
                                 width="160"
                                 show-overflow-tooltip>
                </el-table-column>
                <!--作品/回答提交人-->
                <el-table-column prop="worksSubmitterName"
                                 label="提交人"
                                 header-align="center"
                                 align="center"
                                 width="100"
                                 show-overflow-tooltip></el-table-column>
                <!--回复数-->
                <el-table-column prop="replyNum"
                                 label="回复数"
                                 header-align="center"
                                 align="center"
                                 width="100"
                                 show-overflow-tooltip></el-table-column>
                <!--提交时间-->
                <el-table-column prop="createTime"
                                 label="提交时间"
                                 header-align="center"
                                 align="center"
                                 width="160"
                                 show-overflow-tooltip></el-table-column>
                <!--评论内容-->
                <el-table-column prop="content"
                                 label="评论内容"
                                 header-align="center"
                                 align="left"
                                 width="350"
                                 show-overflow-tooltip></el-table-column>
                <!--状态-->
                <el-table-column prop="status"
                                 label="状态"
                                 header-align="center"
                                 show-overflow-tooltip
                                 :formatter="statusformat"
                                 width="100"
                                 align="center"></el-table-column>
                <!--图片-->
                <el-table-column label="图片"
                                 header-align="center"
                                 show-overflow-tooltip
                                 width="100"
                                 align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.contentList && scope.row.contentList.length > 0">
                            <span class="el-dropdown-link" @click="showView(scope.row)">查看</span>
                            <viewer v-show="viewFlag" :images="imageList" ref="viewer">
                                <img
                                v-for="(url,index) in imageList"
                                style="width:100%" alt=""
                                :src="url"
                                :key="index">
                            </viewer>
                        </div>
                        <div v-else>–</div>
                    </template>
                </el-table-column>
                <!--操作-->
                <el-table-column label="操作"
                                 header-align="center"
                                 align="center"
                                 fixed="right">
                    <template slot-scope="scope">
                        <div>
                            <el-dropdown trigger="click"
                                         placement="bottom">

                                <span class="el-dropdown-link">操作<em class="el-icon-caret-bottom el-icon--right"></em>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <!--显示回复按钮 -->
                                    <el-dropdown-item v-if="scope.row.status != 30" @click.native="reply(scope.row)">回复
                                    </el-dropdown-item>
                                    <!--显示屏蔽按钮-->
                                    <el-dropdown-item v-if="scope.row.status != 30" @click.native="shield(scope.row)">屏蔽
                                    </el-dropdown-item>
                                    <!--显示明细按钮-->
                                    <el-dropdown-item v-if="scope.row.replyNum > 0"
                                                      @click.native="detail(scope.row)">
                                        明细
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="limit"
                           :total="total"
                           layout="total, sizes, prev, pager, next, jumper"
                           @size-change="pageSizeChangeHandle"
                           @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>
        <!-- 回复 -->
        <el-dialog :visible.sync="isShowReply"
                width="50%"
                center>
            <el-form label-position="left"
                    :model="dataFormReply"
                    :rules="dataRule"
                    ref="ruleForm"
                    class="demo-ruleForm">
                    <el-form-item label="标题"
                                class="search-item">
                        <span>{{dataFormReply.worksTitle}}</span>
                    </el-form-item>
                    <hr/>
                    <el-form-item label="评论用户"
                                class="search-item">
                        <span>{{dataFormReply.userName}}</span>
                    </el-form-item>
                    <el-form-item label="所属公司"
                                class="search-item">
                        <span>{{dataFormReply.dealerAbbreviation}}</span>
                    </el-form-item>
                    <el-form-item label="评论内容"
                                class="search-item">
                        <span>{{dataFormReply.content}}</span>
                    </el-form-item>
                    <el-form-item label="回复"
                                  prop="replyContent"
                                  class="search-item">
                        <el-input v-model="dataFormReply.replyContent" :autosize="{minRows: 3}" type="textarea"  maxlength="500" ></el-input>
                    </el-form-item>
            </el-form>
            <div style="text-align: right; margin-top: 20px">
                <el-button type="primary" @click="replySubmit(dataFormReply)" :disabled="disableReply">确 定</el-button>
                <el-button @click="isShowReply = false">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 屏蔽 -->
        <el-dialog title="确认提示"
                :visible.sync="isShowShield"
                width="30%">
            <div style="text-align: center">确认要屏蔽该评论的所有回复信息吗？</div>
            <div style="text-align: center; margin-top: 30px">
                <el-button type="primary" @click="shieldSubmit(shieldData)" :disabled="disableShield">确 定</el-button>
                <el-button @click="isShowShield = false">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 明细 -->
        <el-dialog :visible.sync="isShowDetail"
                :before-close="closeDetail"
                width="850px"
                center>
            <div style="height:300px">
              <el-table :data="replyList"
                    highlight-current-row
                    border
                    height=300>
                <!-- 回复ID -->
                <el-table-column prop="id"
                                label="回复ID"
                                width="170"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"></el-table-column>
                <!-- 回复用户 -->
                <el-table-column prop="userName"
                                label="回复用户"
                                width="110"
                                header-align="center"
                                show-overflow-tooltip
                                align="left">
                </el-table-column>
                <!-- 回复时间 -->
                <el-table-column prop="updateTime"
                                label="回复时间"
                                width="160"
                                header-align="center"
                                :show-overflow-tooltip="true"
                                align="left">
                </el-table-column>
                <!-- 回复内容 -->
                <el-table-column prop="content"
                                label="回复内容"
                                width="260"
                                header-align="center"
                                show-overflow-tooltip
                                align="left">
                </el-table-column>
                <!-- 操作 -->
                <el-table-column label="操作"
                                width="100"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                    <template slot-scope="scope">
                        <div  v-if="scope.row.replyStatus != 30">
                            <el-dropdown trigger="click"
                                         placement="bottom">
                                <span class="el-dropdown-link">操作<em class="el-icon-caret-bottom el-icon--right"></em>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <!--显示回复按钮 -->
                                    <el-dropdown-item @click.native="replyDetail(scope.row)">回复
                                    </el-dropdown-item>
                                    <!--显示屏蔽按钮-->
                                    <el-dropdown-item @click.native="shieldDetail(scope.row)">屏蔽
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div v-else>已屏蔽</div>
                    </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 回复 -->
            <el-dialog :visible.sync="isShowReply2"
                    width="50%"
                    center
                    append-to-body>
                <el-form label-position="left"
                        :model="dataFormReply2"
                        :rules="dataRule2"
                        ref="ruleForm2"
                        class="demo-ruleForm">
                        <el-form-item label="回复者"
                                    class="search-item">
                            <span>{{dataFormReply2.userName}}</span>
                        </el-form-item>
                        <el-form-item label="回复时间"
                                    class="search-item">
                            <span>{{dataFormReply2.updateTime}}</span>
                        </el-form-item>
                        <el-form-item label="回复内容"
                                    class="search-item">
                            <span>{{dataFormReply2.content}}</span>
                        </el-form-item>
                        <el-form-item label="回复"
                                    prop="replyContent2"
                                    class="search-item">
                            <el-input v-model="dataFormReply2.replyContent2" :autosize="{minRows: 3}" type="textarea" maxlength="500" ></el-input>
                        </el-form-item>
                </el-form>
                <div style="text-align: right; margin-top: 20px">
                    <el-button type="primary" @click="replySubmit2(dataFormReply2)" :disabled="disableReply2">确 定</el-button>
                    <el-button @click="isShowReply2 = false">取 消</el-button>
                </div>
            </el-dialog>
            <!-- 屏蔽 -->
            <el-dialog title="确认提示"
                    :visible.sync="isShowShield2"
                    width="30%"
                    append-to-body>
                <div style="text-align: center">确认要屏蔽该回复信息吗？</div>
                <div style="text-align: center; margin-top: 30px">
                    <el-button type="primary" @click="shieldSubmit2(shieldData2)" :disabled="disableShield2">确 定</el-button>
                    <el-button @click="isShowShield2 = false">取 消</el-button>
                </div>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    export default {
        name: "commentManage",
        mixins: [mixinViewModule],
        data () {
            return {
                mixinViewModuleOptions: {
                    getDataListURL: '/grow/cocreationsharingcomment/findPage',
                    getDataListIsPage: true
                },
                submitTime: '', // 提交时间
                approveTime: '', // 审批时间
                dataList: [],
                viewFlag: false,
                imageList: [],
                dataFormReply: {},
                isShowReply: false,
                isShowShield: false,
                isShowDetail: false,
                shieldData: {},
                replyList: [],
                isShowReply2: false,
                isShowShield2: false,
                dataFormReply2: {},
                shieldData2: {},
                disableReply: false,
                disableReply2: false,
                disableShield: false,
                disableShield2: false,
                dataRule: {
                    replyContent: [
                        { required: true, message: "请输入回复内容", trigger: 'blur' }
                    ]
                },
                dataRule2: {
                    replyContent2: [
                        { required: true, message: "请输入回复内容", trigger: 'blur' }
                    ]
                },
                dataForm: {
                    title: '', // 标题
                    tag: '', // 标签
                    worksSubmitter: '', // 作品/回答提交人
                    status: '', // 状态
                    worksApprove: '', // 作品审批人
                    beginSubmitTime: '', // 提交时间
                    endSubmitTime: '', // 提交时间
                    beginApproveTime: '', // 审批时间
                    endApproveTime: '', // 审批时间
                    manageType: '' //类型
                },
                // 等待转圈
                dataListLoading: false,
                moreList: false,
                statusOptions: [
                    {name: "未回复",
                     value: "10"},
                    {name: "已回复",
                     value: "20"},
                    {name: "已屏蔽",
                     value: "30"},
                ],
                manageTypeOptions: [
                  {name: "作品",
                    value: "1"},
                  {name: "提问",
                    value: "2"},
                  {name: "回答",
                    value: "3"}
                ]
            }
        },
        components: {
        },
        methods: {
            // 查看
            showView (data) {
                this.imageList = []
                data.contentList.forEach((file) => {
                    this.imageList.push(file.content)
                })
                this.$refs['viewer'].$viewer.show()
            },
            // 回复
            reply(data) {
                this.dataFormReply = data
                this.isShowReply = true
                this.disableReply = false
            },
            // 回复确认
            replySubmit(data) {
              console.log('&content=+++++++' + data.replyContent)
                this.disableReply = true
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        // let url = '/grow/cocreationsharingreply/reply?commentId=' + data.id + '&content=' + data.replyContent
                        // this.$request.post(url)
                      this.$request
                          .post('/grow/cocreationsharingreply/reply', {
                            commentId: data.id,
                            content: data.replyContent
                          })
                            .then((res, total, code, data) => {
                                this.isShowReply = false
                                this.$message({
                                    message: '回复成功',
                                    type: 'success',
                                    duration: 1000
                                })
                                this.getDataList()
                            })
                            .catch(() => {
                                this.disableReply = false
                            })
                    }
                });
            },
            // 屏蔽
            shield(data) {
                this.isShowShield = true
                this.disableShield = false
                this.shieldData = data
            },
            // 屏蔽确认
            shieldSubmit(data) {
                this.disableShield = true
                let url = '/grow/cocreationsharingcomment/blockComment?commentId=' + data.id
                this.$request
                    .post(url)
                    .then((res, total, code, data) => {
                        this.isShowShield = false
                        this.$message({
                            message: '屏蔽成功',
                            type: 'success',
                            duration: 1000
                        })
                        this.getDataList()
                    })
                    .catch(() => {
                        this.disableShield = false
                    })
            },
            // 明细
            detail(data) {
                this.isShowDetail = true
                this.getDetail(data.id)
            },
            getDetail(commentId) {
                this.$request.get('/grow/cocreationsharingreply/getReplyDetailList', {
                    commentId: commentId
                    })
                    .then((res, total, code, data) => {
                        this.replyList = data.data
                    })
            },
            // 明细关闭
            closeDetail() {
                this.isShowDetail = false
                this.getDataList()
            },
            // 明细回复
            replyDetail(data) {
                this.dataFormReply2 = data
                this.isShowReply2 = true
                this.disableReply2 = false
            },
            // 明细回复确认
            replySubmit2(data) {
              console.log("&content="+data.replyContent2)
              console.log("commentId222="+data.commentId)
              console.log("replyId222"+data.id)
                this.disableReply2 = true
                this.$refs['ruleForm2'].validate((valid) => {
                    if (valid) {
                        this.isShowReply2 = false
                        let commentId = data.commentId
                        // let url = '/grow/cocreationsharingreply/reply?commentId=' + data.commentId + '&replyId=' + data.id + '&content=' + data.replyContent2
                        //
                        // this.$request.post(url)
                        this.$request
                          .post('/grow/cocreationsharingreply/reply', {
                            commentId: data.commentId,
                            replyId:data.id,
                            content: data.replyContent2
                          })
                            .then((res, total, code, data) => {

                                this.getDetail(commentId)
                                this.$message({
                                    message: '回复成功',
                                    type: 'success',
                                    duration: 1000
                                })
                            })
                            .catch(() => {
                                this.disableReply2 = false
                            })
                    }
                });
            },
            // 明细屏蔽
            shieldDetail(data) {
                this.isShowShield2 = true
                this.disableShield2 = false
                this.shieldData2 = data
            },
            // 明细屏蔽确认
            shieldSubmit2(data) {
                this.disableShield2 = true
                let commentId = data.commentId
                let url = '/grow/cocreationsharingreply/blockReply?replyId=' + data.id
                this.$request.post(url)
                    .then((res, total, code, data) => {
                        this.isShowShield = false
                        this.$message({
                            message: '屏蔽成功',
                            type: 'success',
                            duration: 1000
                        })
                        this.isShowShield2 = false
                        this.getDetail(commentId)
                    })
                    .catch(() => {
                        this.disableShield2 = false
                    })

            },
            // 查询
            getDataListMerge () {
                this.page = 1
                this.limit = 10
                if (this.submitTime != null && this.submitTime !== '') {
                    this.dataForm.beginSubmitTime = this.submitTime[0]
                    this.dataForm.endSubmitTime = this.submitTime[1]
                }else {
                    this.dataForm.beginSubmitTime = null
                    this.dataForm.endSubmitTime = null
                }
                if (this.approveTime != null && this.approveTime !== '') {
                    this.dataForm.beginApproveTime = this.approveTime[0]
                    this.dataForm.endApproveTime = this.approveTime[1]
                }
                this.getDataList()
            },
            // 重置
            again () {
                this.dataForm = {
                    title: '', // 标题
                    dealerId: '', // 所属公司简称
                    worksSubmitter: '', // 作品/回答提交人
                    positionGroupType: '', // 职位团队分类
                    positionName: '', // 职位名称
                    workStatus: '', // 作品状态
                    tag: '', // 标签
                    worksApprove: '', // 作品审批人
                    beginSubmitTime: '', // 提交时间
                    endSubmitTime: '', // 提交时间
                    beginApproveTime: '', // 审批时间
                    endApproveTime: '', // 审批时间
                    manageType: ''
                }
                this.submitTime = ''
                this.approveTime = ''
                this.getDataListMerge()
            },
            statusformat (row, column, cellValue) {
                if (cellValue === 10) {
                    return '未回复'
                } else if (cellValue === 20) {
                    return '已回复'
                } else if (cellValue === 30) {
                    return '已屏蔽'
                } else { return ' ' }
            },
            manageTypeformat (row, column, cellValue) {
                if (cellValue == '1') {
                  return '作品'
                }else if(cellValue =='2'){
                  return '提问'
                }else if (cellValue =='3') {
                  return '回答'
                } else { return ' ' }
            }
        }
    }
</script>
<style lang="scss" scoped>
@import "../../css/pkg-styles.css";
.el-date-editor.el-input {
    width: 150px;
}
.search-item {
    width: 94%!important;
}
    .search-item .el-form-item__content {
        margin-left: 96px !important;
    }
.el-row {
    margin-bottom: 0px;
}
.search {
    height: 50px;
}
</style>
<style lang="scss">
.grow-comment-manage {
    .search-item .el-form-item__content {
        margin-left: 96px !important;
    }

}
.demo-ruleForm {
    .el-form-item__content {
        padding-left: 96px !important;
    }
}
</style>
